import type { Authority } from '@/types/app'

export const hasAuthority =
  (authorities: Authority[]) => (toBeVerified: Authority) =>
    authorities.includes(toBeVerified)

export const hasAllAuthorities =
  (authorities: Authority[]) => (toBeVerified: Authority[]) =>
    toBeVerified.every(target => authorities.includes(target))

export const hasAnyAuthorities =
  (authorities: Authority[]) => (toBeVerified: Authority[]) =>
    toBeVerified.some(target => authorities.includes(target))
